import mitt from 'mitt';
import { ViewerModeEnum } from '../store/viewerState/ViewerMode/ViewerMode';
import CommandIdEnum from '../enums/CommandIdEnums';
import { UUID } from '../utils/typeDefinitions';


export type CommandLaunchEvent = {
  commandId: CommandIdEnum;
  parameters?: unknown;
};

// Define the events and their types
type AppEvents = {
  viewerModeChange: ViewerModeEnum;
  commandLaunch: CommandLaunchEvent;
  commandStop: undefined;
  editCommandCommit: { ownerUuid: UUID };
  editCommandEnd: { ownerUuid: UUID };
  // Camera has come to rest — view-angle-dependent UI (e.g. edit handles) can re-evaluate.
  cameraRest: undefined;
};

// Create and export the emitter
export const emitter = mitt<AppEvents>();
